import { Button, Input, Modal, NettgravSpinner } from 'design-system';
import { Form } from 'design-system/compat';
import { useState } from 'react';
import Header from '../CreateMembership/Header';

import axios from 'axios';
import { showNotification } from 'design-system';
import { InfoIcon } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CONSTANTS } from '../../../service/constants';
import styles from './LoginForm.module.css';

const ForgotPassword = ({ setHideLoginForm }) => {
  const intl = useIntl();
  const [email, setEmail] = useState('');
  const [isSendingResetLink, setIsSendingResetLink] = useState(false);
  const [form] = Form.useForm();

  const sendRestLink = () => {
    form
      .validateFields()
      .then(() => {
        setIsSendingResetLink(true);
        const data = { email };
        const config = {
          redirect: 'follow',
          headers: {
            Accept: '*/*',
          },
        };
        axios
          .post(`${CONSTANTS.baseUrl}/api/generate_auth_token_for_forgot_passwords`, data, config)
          .then(() => {
            setIsSendingResetLink(false);
            Modal.confirm({
              icon: <InfoIcon size={24} aria-hidden style={{ color: 'var(--success)' }} />,
              title: intl.formatMessage({ id: 'forgot_password_title' }),
              content: intl.formatMessage({ id: 'forgot_password_message' }),
            });
          })
          .catch((err) => {
            setIsSendingResetLink(false);
            showNotification(err.response?.data?.error || err.message, 'error', 'auth');
          });
      })
      .catch(() => {});
  };

  return (
    <>
      <Header headingKey="forgot_password_heading" messageKey="forgot_password_description" />
      <Form
        form={form}
        layout="vertical"
        onFinish={sendRestLink}
        autoComplete="off"
        className={styles.form}
      >
        <Form.Item
          name="email"
          label={<FormattedMessage id="settings_billingEmail" />}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'email_error' }),
            },
            {
              type: 'email',
              message: intl.formatMessage({ id: 'account_form_email_invalid' }),
            },
          ]}
        >
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={intl.formatMessage({ id: 'type_your_email' })}
          />
        </Form.Item>
        <div className={styles['for-btn-container']}>
          <Button onClick={() => setHideLoginForm(false)} shape="round">
            <FormattedMessage id="auth_back" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            shape="round"
            loading={isSendingResetLink}
            disabled={isSendingResetLink}
          >
            <FormattedMessage id="forgot_password_button" />
          </Button>
        </div>
      </Form>
      {isSendingResetLink && (
        <div className={styles.loadingOverlay} role="status" aria-live="assertive">
          <div className={styles.loadingContent}>
            <NettgravSpinner size={40} className="ng-spinner--brand" />
            <span className={styles.loadingMessage}>
              <FormattedMessage id="forgot_password_waiting" />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
